module.exports = __webpack_public_path__ + "static/media/h_logo.3d029a95.webp";